import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { RecordEditorProvider } from "@/components/explorer/RecordEditor";
import { NotificationsProvider, useNotifications } from "@/context/NotificationsContext";
import { useAuth } from "@/context/AuthContext";
import { NAV } from "./navConfig";

const SeenOnVisit = () => {
  const { pathname } = useLocation();
  const { seeSection } = useNotifications();
  useEffect(() => {
    const item = NAV.find((n) => n.path !== "/" && pathname.startsWith(n.path));
    if (item && item.key !== "notifications") seeSection([item.key]);
  }, [pathname, seeSection]);
  return null;
};

function Shell() {
  const [sidebar, setSidebar] = useState(false);
  return (
    <div className="min-h-screen bg-background">
      <Sidebar open={sidebar} onClose={() => setSidebar(false)} />
      <div className="lg:pl-64">
        <Topbar onMenu={() => setSidebar(true)} />
        <main className="p-4 sm:p-6 lg:p-8 max-w-[1600px] mx-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export function AppLayout() {
  const { user } = useAuth();
  if (user?.role === "field") return <RecordEditorProvider><Shell /></RecordEditorProvider>;
  return (
    <RecordEditorProvider>
      <NotificationsProvider>
        <SeenOnVisit />
        <Shell />
      </NotificationsProvider>
    </RecordEditorProvider>
  );
}
